import { connect } from 'react-redux'

import ServiceModificationPenalty from './ServiceModificationPenalty'
import {
  fetchUpdatePenalty as fetchPenalty,
  getPenalty
} from '@src/redux/modules/service'

const mapStateToProps = (state, ownProps) => {
  const penalty = getPenalty(state)
  return {
    penalty,
    onPenaltyFetched: ownProps.onPenaltyFetched,
    serviceId: ownProps.serviceId,
    serviceModifications: ownProps.serviceModifications
  }
}

const mapDispatchToProps = {
  fetchPenalty
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceModificationPenalty)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Services/screens/shared/components/ServiceModificationPenalty/ServiceModificationPenaltyContainer.js